import React, { createContext, useContext, useEffect, useState} from 'react';
import Cookies from 'js-cookie';


const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const [subscribed, setSubscribed] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState("free");

  const checkSubscription = Cookies?.get("subscription");

  useEffect(() => {
    if(!checkSubscription){
      return
    }
    setSubscribed(checkSubscription)
  },[checkSubscription])
 

  return (
    <SubscriptionContext.Provider value={{ subscribed, setSubscribed, subscriptionPlan, setSubscriptionPlan }}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => useContext(SubscriptionContext);